export default "__VITE_ASSET__DGf5bDR1__"